import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Checkbox, Input, Field, Loader, Select } from '../../../../itds/elements/index.js';

const getInitialDataSource = uq => {
  if (uq?.is_live) return 'Live';
  if (uq?.is_beta) return 'Beta';
  return '';
};

const General = ({ universal_quoter, handleSave }) => {
  const [data, setData] = useState({
    is_deactivated: universal_quoter?.is_deactivated || false,
    data_source: getInitialDataSource(universal_quoter),
    name: universal_quoter?.name || '',
    is_archived: universal_quoter?.is_archived || false,
    is_health_analyzer_reasoning_enabled: universal_quoter?.is_health_analyzer_reasoning_enabled || false,
    default_lob: universal_quoter?.default_lob || 1 // Default to Annuity (1)
  });

  const [errors, setErrors] = useState([]);

  const handleArchiveToggle = () => {
    setData({ ...data, is_archived: !data.is_archived });
    handleSave({ is_archived: !data.is_archived });
  };

  const handleChange = (name, e) => {
    setData({ ...data, [name]: e.target.value });
  };

  const handleCheck = (name, e) => {
    setData({ ...data, [name]: e.target.checked });
  };

  const save = () => {
    const errors = [];

    if (!data.name) {
      errors.push('name');
    }

    setErrors(errors);

    if (!errors.length) {
      const requestData = {
        ...data,
        is_beta: data.data_source === 'Beta',
        is_live: data.data_source === 'Live'
      };

      handleSave(requestData);
    }
  };

  if (!universal_quoter) return <Loader />;

  return (
    <>
      <Field label='Token' style={{}}>
        <Input
          readOnly={true}
          value={universal_quoter.token || universal_quoter.quoter_token_id || ''}
        />
      </Field>
      <Field label='' style={{}}>
        <Checkbox
          checked={data.is_deactivated}
          disabled={data.is_archived}
          label='Deactivated'
          onChange={handleCheck.bind(null, 'is_deactivated')}
        />
      </Field>
      <Field label='Name' style={{}}>
        <Input
          invalid={errors.includes('name')}
          onChange={handleChange.bind(null, 'name')}
          readOnly={data.is_deactivated || data.is_archived}
          required={true}
          value={data.name || ''}
        />
      </Field>
      <Field label='Data Source' style={{}}>
        <Select
          onChange={handleChange.bind(null, 'data_source')}
          options={[{ value: 'Live' }, { value: 'Beta' }]}
          placeholder='-- Select Data Source --'
          readOnly={data.is_deactivated || data.is_archived}
          style={{}}
          value={data.data_source}
        />
      </Field>
      <Field label='' style={{}}>
        <Checkbox
          checked={data.is_health_analyzer_reasoning_enabled}
          disabled={data.is_deactivated || data.is_archived}
          label='Health Analyzer Reasoning'
          onChange={handleCheck.bind(null, 'is_health_analyzer_reasoning_enabled')}
        />
      </Field>
      <Field label='Default Line of Business'>
        <div>
          <label style={{ display: 'block', marginBottom: '8px', cursor: data?.is_deactivated || data?.is_archived ? 'not-allowed' : 'pointer', opacity: data?.is_deactivated || data?.is_archived ? 0.6 : 1 }}>
            <input
              type="radio"
              name="default_lob"
              value={1}
              checked={data?.default_lob === 1}
              disabled={data?.is_deactivated || data?.is_archived}
              onChange={() => setData({ ...data, default_lob: 1 })}
              style={{ marginRight: '8px' }}
            />
            Annuity
          </label>
          <label style={{ display: 'block', cursor: data?.is_deactivated || data?.is_archived ? 'not-allowed' : 'pointer', opacity: data?.is_deactivated || data?.is_archived ? 0.6 : 1 }}>
            <input
              type="radio"
              name="default_lob"
              value={2}
              checked={data?.default_lob === 2}
              disabled={data?.is_deactivated || data?.is_archived}
              onChange={() => setData({ ...data, default_lob: 2 })}
              style={{ marginRight: '8px' }}
            />
            Life
          </label>
        </div>
      </Field>
      
      <div style={{ display: 'flex', marginTop: 40 }}>
        <Button color='RED' onClick={handleArchiveToggle} style={{ marginRight: '5px' }}>
          {data.is_archived ? 'Unarchive' : 'Archive'}
        </Button>
        {data.is_archived ? null : (
          <Button onClick={save} style={{}}>
            Save Changes
          </Button>
        )}
      </div>
    </>
  );
};

General.propTypes = {
  handleSave: PropTypes.func,
  universal_quoter: PropTypes.object
};

export default General;
